import { render, staticRenderFns } from "./node-list-carousel-only-image-slide.vue?vue&type=template&id=60710ec9"
import script from "./node-list-carousel-only-image-slide.vue?vue&type=script&lang=js"
export * from "./node-list-carousel-only-image-slide.vue?vue&type=script&lang=js"
import style0 from "./node-list-carousel-only-image-slide.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports